__turbopack_context__.v({
  "agentPromptBlock": "ngc47q_agentPromptBlock",
  "agentPromptCard": "ngc47q_agentPromptCard",
  "agentPromptCardBody": "ngc47q_agentPromptCardBody",
  "agentPromptCardCode": "ngc47q_agentPromptCardCode",
  "agentPromptCardFade": "ngc47q_agentPromptCardFade",
  "agentPromptCardFadeArea": "ngc47q_agentPromptCardFadeArea",
  "agentPromptCardHeader": "ngc47q_agentPromptCardHeader",
  "agentPromptCardIcon": "ngc47q_agentPromptCardIcon",
  "agentPromptCardInner": "ngc47q_agentPromptCardInner",
  "agentPromptCardLabel": "ngc47q_agentPromptCardLabel",
  "agentPromptCopyButton": "ngc47q_agentPromptCopyButton",
  "agentPromptDialog": "ngc47q_agentPromptDialog",
  "agentPromptExpand": "ngc47q_agentPromptExpand",
  "agentPromptModalBody": "ngc47q_agentPromptModalBody",
  "agentPromptModalCode": "ngc47q_agentPromptModalCode",
  "agentPromptModalHeader": "ngc47q_agentPromptModalHeader",
  "agentPromptModalRoot": "ngc47q_agentPromptModalRoot",
  "agentPromptModalTitle": "ngc47q_agentPromptModalTitle",
  "backButton": "ngc47q_backButton",
  "bodyText": "ngc47q_bodyText",
  "bodyTextStrong": "ngc47q_bodyTextStrong",
  "checklist": "ngc47q_checklist",
  "checklistCard": "ngc47q_checklistCard",
  "checklistCardDescription": "ngc47q_checklistCardDescription",
  "checklistCardDone": "ngc47q_checklistCardDone",
  "checklistCardTitle": "ngc47q_checklistCardTitle",
  "checklistGrid": "ngc47q_checklistGrid",
  "checklistHead": "ngc47q_checklistHead",
  "checklistIcon": "ngc47q_checklistIcon",
  "checklistTitle": "ngc47q_checklistTitle",
  "checklistToggle": "ngc47q_checklistToggle",
  "checklistTop": "ngc47q_checklistTop",
  "chip": "ngc47q_chip",
  "chips": "ngc47q_chips",
  "codeBlock": "ngc47q_codeBlock",
  "error": "ngc47q_error",
  "guideBody": "ngc47q_guideBody",
  "guideBodyLoading": "ngc47q_guideBodyLoading",
  "guideShell": "ngc47q_guideShell",
  "hero": "ngc47q_hero",
  "heroCopy": "ngc47q_heroCopy",
  "heroDescription": "ngc47q_heroDescription",
  "heroIcon": "ngc47q_heroIcon",
  "heroTitle": "ngc47q_heroTitle",
  "icon": "ngc47q_icon",
  "loading": "ngc47q_loading",
  "navGroup": "ngc47q_navGroup",
  "onboarding-page-enter": "ngc47q_onboarding-page-enter",
  "onboarding-prompt-stroke-orbit": "ngc47q_onboarding-prompt-stroke-orbit",
  "onboarding-step-back": "ngc47q_onboarding-step-back",
  "onboarding-step-next": "ngc47q_onboarding-step-next",
  "onboarding-step-swap": "ngc47q_onboarding-step-swap",
  "osPicker": "ngc47q_osPicker",
  "osPickerChevron": "ngc47q_osPickerChevron",
  "osPickerIcon": "ngc47q_osPickerIcon",
  "osPickerLabel": "ngc47q_osPickerLabel",
  "osPickerMenu": "ngc47q_osPickerMenu",
  "osPickerOption": "ngc47q_osPickerOption",
  "osPickerOptionLabel": "ngc47q_osPickerOptionLabel",
  "osPickerTrigger": "ngc47q_osPickerTrigger",
  "outlineButton": "ngc47q_outlineButton",
  "playButton": "ngc47q_playButton",
  "playButtonIcon": "ngc47q_playButtonIcon",
  "primaryButton": "ngc47q_primaryButton",
  "rail": "ngc47q_rail",
  "railLine": "ngc47q_railLine",
  "railLineFade": "ngc47q_railLineFade",
  "railTop": "ngc47q_railTop",
  "requirementsLead": "ngc47q_requirementsLead",
  "root": "ngc47q_root",
  "rootGuideEnter": "ngc47q_rootGuideEnter",
  "rootGuideInstant": "ngc47q_rootGuideInstant",
  "segment": "ngc47q_segment",
  "segmentActive": "ngc47q_segmentActive",
  "segmented": "ngc47q_segmented",
  "setupRow": "ngc47q_setupRow",
  "stackCard": "ngc47q_stackCard",
  "stackCardActive": "ngc47q_stackCardActive",
  "stackLabel": "ngc47q_stackLabel",
  "stackLogo": "ngc47q_stackLogo",
  "stackNavButton": "ngc47q_stackNavButton",
  "stackNavButtonBack": "ngc47q_stackNavButtonBack",
  "stackPickerSection": "ngc47q_stackPickerSection",
  "stackScroller": "ngc47q_stackScroller",
  "stackScrollerFade": "ngc47q_stackScrollerFade",
  "stackScrollerFadeStart": "ngc47q_stackScrollerFadeStart",
  "stackScrollerHasBack": "ngc47q_stackScrollerHasBack",
  "stackScrollerHasForward": "ngc47q_stackScrollerHasForward",
  "stackScrollerHug": "ngc47q_stackScrollerHug",
  "stackTrack": "ngc47q_stackTrack",
  "stepBlock": "ngc47q_stepBlock",
  "stepBlockActive": "ngc47q_stepBlockActive",
  "stepBlockComplete": "ngc47q_stepBlockComplete",
  "stepBlockFirst": "ngc47q_stepBlockFirst",
  "stepBlockNext": "ngc47q_stepBlockNext",
  "stepBody": "ngc47q_stepBody",
  "stepContent": "ngc47q_stepContent",
  "stepHeader": "ngc47q_stepHeader",
  "stepNav": "ngc47q_stepNav",
  "stepNavButton": "ngc47q_stepNavButton",
  "stepNavButtonPrevious": "ngc47q_stepNavButtonPrevious",
  "stepTitle": "ngc47q_stepTitle",
  "stepTitleUpcoming": "ngc47q_stepTitleUpcoming",
  "steps": "ngc47q_steps",
  "stepsMotionBack": "ngc47q_stepsMotionBack",
  "stepsMotionForward": "ngc47q_stepsMotionForward",
  "stepsMotionSwap": "ngc47q_stepsMotionSwap",
  "stepsRefreshing": "ngc47q_stepsRefreshing",
  "stickyBar": "ngc47q_stickyBar",
  "timelineBadge": "ngc47q_timelineBadge",
  "timelineBadgeWrap": "ngc47q_timelineBadgeWrap",
  "timelineCheckmark": "ngc47q_timelineCheckmark",
  "tone0": "ngc47q_tone0",
  "tone1": "ngc47q_tone1",
  "tone2": "ngc47q_tone2",
  "video-modal-enter": "ngc47q_video-modal-enter",
  "video-modal-exit": "ngc47q_video-modal-exit",
  "video-modal-overlay-in": "ngc47q_video-modal-overlay-in",
  "videoModalBody": "ngc47q_videoModalBody",
  "videoModalClose": "ngc47q_videoModalClose",
  "videoModalFrame": "ngc47q_videoModalFrame",
  "videoModalHeader": "ngc47q_videoModalHeader",
  "videoModalOverlay": "ngc47q_videoModalOverlay",
  "videoModalSheet": "ngc47q_videoModalSheet",
  "videoModalTitle": "ngc47q_videoModalTitle",
  "videoPip": "ngc47q_videoPip",
  "videoPipClose": "ngc47q_videoPipClose",
  "videoPipFrame": "ngc47q_videoPipFrame",
  "videoPipHead": "ngc47q_videoPipHead",
  "videoPipMedia": "ngc47q_videoPipMedia",
  "videoPipPlayBadge": "ngc47q_videoPipPlayBadge",
  "videoPipPoster": "ngc47q_videoPipPoster",
  "videoPipThumb": "ngc47q_videoPipThumb",
  "videoPipTitle": "ngc47q_videoPipTitle",
  "visionButton": "ngc47q_visionButton",
  "visionButtonAppIcon": "ngc47q_visionButtonAppIcon",
  "visionButtonLabel": "ngc47q_visionButtonLabel",
});
